const Regex = {
  validateEmail: function (val: any) {
    // eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      val
    );
  },
  validatePassword: function (val: any) {
    return /^(?=.*[A-Za-z])(?=.*[0-9])[A-Za-z0-9]\S{5,16}$/.test(val);
  },
  validateMobile: function (text: any) {
    return /^[6-9]\d{9}$/gi.test(text);
  },
  validatePAN: function (text: any) {
    return /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/.test(text);
  },
  validatePIN_Code: function (text: any) {
    return /^\d{6}$/.test(text);
  },
  validateDate: function (text: any) {
    return /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(text);
  },
  validateNumber: function (text: any) {
    return /^\d+$/.test(text);
  },
  validateIFSCCode: function (text: any) {
    return /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/.test(text);
  },
  validateCharacters: function (text: any) {
    return /^[a-zA-Z]+$/.test(text);
  },
  validateAlphaNumeric: function (text: any) {
    return /^[a-zA-Z0-9]+$/.test(text);
  },
  validateName: function (text: any) {
    return /^[a-zA-Z ]*$/.test(text);
  }
};
export default Regex;
